// @ts-check

import GridExportButton from '~/components/Shared/DataGrid/GridExportButton';
import { useIncidentDataGridContext } from '~/components/Incidents/IncidentDataGrid/IncidentDataGrid.context';

const EXPORTED_ROW_COUNT = 125;

export default function IncidentDataGridExportButton() {
    const { gridRef, setRowCount } = useIncidentDataGridContext();

    return (
        <GridExportButton
            gridRef={gridRef}
            setRowCount={setRowCount}
            exportRowCount={EXPORTED_ROW_COUNT}
            fileName="ZERO Incident Export"
        />
    );
}
